import { estado, getGeoCoords } from "./nucleo";

/* ============================================
   🔐 VALIDACIÓN DE PASSWORD
============================================ */
window.validatePassword = (input) => {
    const value = input.value;
    const hasUppercase = /[A-Z]/.test(value);
    const hasLowercase = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasLength = value.length >= 8;
    const isValid = hasUppercase && hasLowercase && hasNumber && hasLength;

    input.classList.toggle('border-green-500', isValid);
    input.classList.toggle('focus:border-green-500', isValid);
    input.classList.toggle('focus:ring-green-500', isValid);
    input.classList.toggle('border-red-500', !isValid);
    input.classList.toggle('focus:border-red-500', !isValid);
    input.classList.toggle('focus:ring-red-500', !isValid);
};

/* ============================================
   📦 DIRECCIONES Y NAVEGACIÓN
============================================ */
window.directionNav = (auth) => {
    if (auth) {
        $.ajaxSetup({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
        });

        $.ajax({
            url: '/direccionesJson',
            type: 'GET',
            dataType: 'json',
            success: function(response) {
                let html = '<div class="flex flex-col gap-1">';
                response.direcciones.forEach(d => {
                    html += `
                        <div class="cursor-pointer p-4 border rounded-2xl shadow-sm bg-white hover:shadow-md transition"
                             onclick="cambiarPorDireccionUser('${d.cp}','${d.id}')">
                            <div class="flex justify-between items-center mb-2">
                                <h3 class="font-semibold text-lg">${d.nombre_destinatario}</h3>
                                ${d.default == 1 ? '<span class="text-xs px-2 py-1 bg-[#18445f] text-white rounded-full">Predeterminada</span>' : ''}
                            </div>
                            <p class="text-sm text-gray-700">${d.linea1}, ${d.linea2}</p>
                            <p class="text-sm text-gray-700">${d.cp}, ${d.ciudad}, ${d.provincia}</p>
                            <p class="text-sm text-gray-700">${d.telefono}</p>
                        </div>`;
                });

                html += '</div>';
                $("#content-modal-direcciones").html(html);
                $('#modalDirecciones').show();
            },
            error: function(xhr) {
                console.error('Error:', xhr.responseText);
            }
        });
    } else {
        window.openSheet('put-postal-code-modal');
    }
};

/* ============================================
   🧭 INIT AND FILTER NAV
============================================ */
const initAndFilterNav = () => {
    // Sin código postal (ni en localStorage ni en sesión) el servidor responde 400: no llamar.
    const cpDisponible = localStorage.getItem('mt_cp') || document.getElementById('mt_cp')?.textContent.trim();
    if (!cpDisponible) return;

    let plaza_id = document.getElementById('plaza_id')?.value ?? '';
    let inPlaza = window.location.pathname.startsWith("/plazas") && plaza_id !== '';

    const key = 'opcionesEntrega';
    if (!localStorage.getItem(key)) {
        const datosIniciales = { tienda: 0, domicilio: 1 };
        localStorage.setItem(key, JSON.stringify(datosIniciales));
    }

    let datos = JSON.parse(localStorage.getItem(key));

    const selectorTienda    = 'input[data-key="tienda"], input[data-key="tienda-movil"], input[data-key="tienda-plaza"]';
    const selectorDomicilio = 'input[data-key="domicilio"], input[data-key="domicilio-movil"], input[data-key="domicilio-plaza"]';

    $(selectorTienda).prop('checked', datos.tienda === 1);
    $(selectorDomicilio).prop('checked', datos.domicilio === 1);

    const clavesSwitch = {
        domicilio: $(selectorDomicilio),
        tienda: $(selectorTienda)
    };

    // ✅ Cambia el texto de TODOS los <p class="text-switch">
    const actualizarTextoSwitch = () => {
        const modoFinal = clavesSwitch.domicilio.is(':checked') ? 'domicilio' : 'tienda';
        $('.text-switch').text(modoFinal === 'domicilio' ? 'Enviar a' : 'Recoger en');
    };

    // ✅ Texto correcto al iniciar (según localStorage/estado inicial)
    actualizarTextoSwitch();

    if (datos.tienda === 1 || datos.domicilio === 1) {
        $.ajaxSetup({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
        });

        getGeoCoords().then(geo => {
            $.ajax({
                url: '/mercados/filterNav',
                type: 'GET',
                dataType: 'json',
                data: {
                    tienda: datos.tienda,
                    domicilio: datos.domicilio,
                    cp: localStorage.getItem('mt_cp'),
                    inPlaza,
                    plaza_id: plaza_id,
                    genero: window.currentGeneroFilter || '',
                    ...(geo ? { lat: geo.lat, lng: geo.lng } : {})
                },
                success: function(response) {
                    const contenedor = inPlaza
                        ? $('#plaza-tiendas-container').first()
                        : ($('.content-index-in').length ? $('.content-index-in') : $('.bg-white-filter').first());
                    if (contenedor.length) contenedor.html(response.html);

                    actualizarTextoSwitch();
                    if (inPlaza && typeof window.filtrarTiendasPlaza === 'function') window.filtrarTiendasPlaza(undefined);
                    if (typeof window.initDestacadosCarousel === 'function') window.initDestacadosCarousel();
                },
                error: function(xhr) {
                    console.error('Error:', xhr.responseText);
                }
            });
        });
    }

    $('input[data-key]').off('change').on('change', function () {
        const keyReal = $(this).attr('data-key').includes('domicilio') ? 'domicilio' : 'tienda';

        if ($(this).is(':checked')) {
            if (keyReal === "domicilio") clavesSwitch.tienda.prop('checked', false);
            if (keyReal === "tienda") clavesSwitch.domicilio.prop('checked', false);
            clavesSwitch[keyReal].prop('checked', true);
        } else {
            const contrario = keyReal === "domicilio" ? "tienda" : "domicilio";
            clavesSwitch[keyReal].prop('checked', false);
            clavesSwitch[contrario].prop('checked', true);
        }

        actualizarTextoSwitch();

        datos = {
            tienda: clavesSwitch.tienda.is(':checked') ? 1 : 0,
            domicilio: clavesSwitch.domicilio.is(':checked') ? 1 : 0,
        };

        localStorage.setItem(key, JSON.stringify(datos));

        $.ajaxSetup({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
        });

        getGeoCoords().then(geo => {
            $.ajax({
                url: '/mercados/filterNav',
                type: 'GET',
                dataType: 'json',
                data: {
                    tienda: datos.tienda,
                    domicilio: datos.domicilio,
                    cp: localStorage.getItem('mt_cp'),
                    inPlaza,
                    plaza_id,
                    genero: window.currentGeneroFilter || '',
                    ...(geo ? { lat: geo.lat, lng: geo.lng } : {})
                },
                success: function(response) {
                    const contenedor = inPlaza
                        ? $('#plaza-tiendas-container').first()
                        : ($('.content-index-in').length ? $('.content-index-in') : $('.bg-white').first());

                    if (contenedor.length) contenedor.html(response.html);

                    actualizarTextoSwitch();
                    if (inPlaza && typeof window.filtrarTiendasPlaza === 'function') window.filtrarTiendasPlaza(undefined);
                    if (typeof window.initDestacadosCarousel === 'function') window.initDestacadosCarousel();
                },
                error: function(xhr) {
                    console.error('Error:', xhr.responseText);
                }
            });
        });

    });
};

/* ============================================
   🏷️ CATEGORY CHIP FILTER
============================================ */
window.currentGeneroFilter = '';

window.filtrarPorGenero = function(genero, event) {
    if (event) event.preventDefault();

    window.currentGeneroFilter = genero;

    document.querySelectorAll('.mobile-nav-chip').forEach(function(chip) {
        chip.classList.toggle('mobile-nav-chip--active', (chip.getAttribute('data-genero') || '') === genero);
    });

    if (!document.querySelector('.content-index-in')) {
        window.location.href = '/?genero=' + encodeURIComponent(genero);
        return;
    }

    const datos = JSON.parse(localStorage.getItem('opcionesEntrega') || '{"tienda":0,"domicilio":1}');
    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });
    getGeoCoords().then(geo => {
        $.ajax({
            url: '/mercados/filterNav',
            type: 'GET',
            dataType: 'json',
            data: {
                tienda: datos.tienda,
                domicilio: datos.domicilio,
                cp: localStorage.getItem('mt_cp'),
                genero: genero,
                ...(geo ? { lat: geo.lat, lng: geo.lng } : {})
            },
            success: function(response) {
                const contenedor = $('.content-index-in');
                if (contenedor.length) contenedor.html(response.html);
                if (typeof window.initDestacadosCarousel === 'function') window.initDestacadosCarousel();
            }
        });
    });
};

$(document).ready(() => {
    // Pre-apply genre from URL param (e.g. desktop subnav link navigated here)
    const urlParams = new URLSearchParams(window.location.search);
    const generoParam = urlParams.get('genero');
    if (generoParam) {
        window.currentGeneroFilter = generoParam;
        document.querySelectorAll('.mobile-nav-chip').forEach(function(chip) {
            chip.classList.toggle('mobile-nav-chip--active', (chip.getAttribute('data-genero') || '') === generoParam);
        });
    }

    $(document).on('click', '.mobile-nav-chip', function() {
        window.filtrarPorGenero($(this).attr('data-genero') || '');
    });

    if (!window.location.href.includes('/search')) {
        initAndFilterNav();
    }

    window.addEventListener('scroll', async () => {
    if (estado.isLoadingMore) return;

    const scrollTop = window.scrollY;
    const viewportHeight = window.innerHeight;
    const fullHeight = document.body.offsetHeight;

    if (scrollTop + viewportHeight >= fullHeight - 300) {
        estado.isLoadingMore = true;
        estado.currentPage++;

        await handleFilterChange(true); 
        estado.isLoadingMore = false;
        }
    });

    const arrow = document.getElementById("filters_arrow");
    const content = document.getElementById("filters_content");

    if (window.innerWidth >= 768) {
        arrow?.classList.add("rotate-180");
    }

});
